import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { premiumPaths } from "../navigation";

export default function PremiumTabs({
  company,
  admin,
  adminDictionaries = admin,
}) {
  const { dictionaryKind } = useParams();
  const companyId = company.id;
  const kind = dictionaryKind || company.plugin?.dictionaries?.[0]?.kind;
  const certificates = {
    label: "Świadectwa",
    to: premiumPaths.orders(companyId),
  };
  const dictionary = kind && {
    label: "Słowniki",
    to: premiumPaths.dictionary(companyId, kind, adminDictionaries),
  };
  const items = admin
    ? [
        { label: "Ustawienia", to: premiumPaths.settings(companyId) },
        { label: "Użytkownicy", to: premiumPaths.members(companyId) },
        dictionary,
        certificates,
      ]
    : [certificates, dictionary];
  return (
    <nav
      className="premium-tabs nav nav-tabs"
      aria-label="Sekcje firmy Premium"
    >
      {items.filter(Boolean).map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
